import {Box, Card, Divider, Typography} from '@material-ui/core';
import React from 'react';
import {IFarmInputInvoice} from 'constants/interfaces';
import {Skeleton} from '@material-ui/lab';

export function InvoiceLogisticsCard(props: {
  invoice?: IFarmInputInvoice;
  isLoading?: boolean;
}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={200} style={{borderRadius: 8}} />;
  if (!props.invoice) return null;
  const {invoice} = props;
  return (
    <Card className="invoice-logistics-card" variant="outlined">
      <Box className="row">
        <Box className="product-container">
          <Typography className="bold" variant="body2">
            Product
          </Typography>
        </Box>
        <Box className="quantity-container">
          <Typography className="bold" variant="body2">
            Qty
          </Typography>
        </Box>
        <Box className="logistics-name-container">
          <Typography className="bold" variant="body2">
            Logistics Type
          </Typography>
        </Box>
        <Box className="status-container">
          <Typography className="bold" variant="body2">
            Status
          </Typography>
        </Box>
      </Box>
      {invoice.orders.map((order) => (
        <div key={order.id}>
          <Divider />
          <Box className="row">
            <Box className="product-container">
              <Typography variant="body2" color="textSecondary">
                {order.product.name}
              </Typography>
            </Box>
            <Box className="quantity-container">
              <Typography variant="body2" color="textSecondary">
                {order.quantity}
              </Typography>
            </Box>
            <Box className="logistics-name-container">
              <Typography variant="body2" color="textSecondary">
                {order.logisticsTypeName || invoice.deliveryType}
              </Typography>
            </Box>
            <Box className="status-container">
              <Typography variant="body2" color="textSecondary">
                {order.isDelivered ? 'Delivered' : 'Pending'}
              </Typography>
            </Box>
          </Box>
        </div>
      ))}
    </Card>
  );
}
